export interface AppEnvironment {
    version: string;
    build: number;
    local: boolean;
    debug: boolean;
    production: boolean;
    stage: Environments;
    apiUrl: string;
    echo: {
        key: string;
        wsHost: string;
        wsPort: number;
        wssPort: number;
        scheme: 'http' | 'https';
    };
    recaptcha: string;
}

export enum Environments {
    Local,
    Development,
    Staging,
    Production,
}
